const initBannerImagesLazyLoading = () => {
    const bannerImages = $("picture.banner-image-loading");

    bannerImages.each((index, picture) => {
        const $picture = $(picture);
        const imagem   = $picture.find("img").get(0);

        if (!imagem) {
            return;
        }

        if ($picture.hasClass("banner-image-loading--lcp")
            || $picture.closest(".banner--lcp-priority").length) {
            $picture.addClass("is-loaded");
            return;
        }

        const markLoaded = () => {
            $picture.addClass("is-loaded");
        };

        if (imagem.complete) {
            markLoaded();
        } else {
            $(imagem).on("load", markLoaded);
        }
    });
};

const initImagesComponents = () => {
    initBannerImagesLazyLoading();
};

export default initImagesComponents;
